module.exports = __webpack_public_path__ + "img/more.4c5e0dec.svg";